import React, { Component } from 'react';

export class OnlyUpdatesOnUserProfileChangedComponent extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        console.log('checking if component should update');
        console.log(nextProps);
        const stateChanged = JSON.stringify(this.state) !== JSON.stringify(nextState);
        const userProfileChanged = JSON.stringify(this.props.user.userProfile) !== JSON.stringify(nextProps.user.userProfile);
        return stateChanged || userProfileChanged;
    }
}
